"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setServerDown = exports.setHosts = void 0;
const types_1 = require("./types");
function setHosts(hosts) {
    return {
        type: types_1.SET_HOSTS,
        hosts,
    };
}
exports.setHosts = setHosts;
function setServerDown(isDown) {
    return {
        type: types_1.SET_SERVER_DOWN,
        isDown,
    };
}
exports.setServerDown = setServerDown;
